import * as FPT from './fpt'

/**
 * Loads bodymovin and hearts animation json
 */
export function loadBodyMovin() {
	return Promise.all([
		import(/* webpackChunkName: 'bodymovin' */ 'bodymovin'),
		import(/* webpackChunkName: 'hearts' */ '../vendor/hearts.json'),
	])
	.catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'bodymovin'
		});
	})
}

/**
 * Load Progressive Onboarding component
 */
export function loadProgressiveOnboarding() {
	return Promise.all([
		import(/* webpackChunkName: 'Progressiveonboarding' */ '../../../node_modules/portableonboarding/build/portableComponents')
	]).catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'progressive'
		});
	})
}



// WEBPACK FOOTER //
// ./utility/lazyLoader.js